module.exports = __webpack_public_path__ + "static/img/sp_preview.d220117.png";